import { BrowserRouter, Routes, Route, Navigate } from 'react-router-dom';
import { AuthProvider } from './context/AuthContext';
import { LookupProvider } from './context/LookupContext';
import { ReportFiltersProvider } from './context/ReportFiltersContext';
import ProtectedRoute from './components/layout/ProtectedRoute';

import LoginPage from './pages/LoginPage';
import QueuePage from './pages/QueuePage';
import OrderDetailPage from './pages/OrderDetailPage';
import NewOrderPage from './pages/NewOrderPage';
import SearchPage from './pages/SearchPage';
import AdminPage from './pages/AdminPage';
import { FinancialsPage, ProductivityPage, CallReportPage } from './pages/ReportPages';

import './styles/global.css';

export default function App() {
  return (
    <BrowserRouter>
      <AuthProvider>
        <LookupProvider>
          <ReportFiltersProvider>
          <Routes>
            {/* Public */}
            <Route path="/login" element={<LoginPage />} />

            {/* Redirect root to queue */}
            <Route path="/" element={<Navigate to="/queue" replace />} />

            {/* Processor + Admin */}
            <Route path="/queue"       element={<ProtectedRoute><QueuePage /></ProtectedRoute>} />
            <Route path="/my-files"    element={<ProtectedRoute><QueuePage myFilesOnly={true} /></ProtectedRoute>} />
            <Route path="/search"      element={<ProtectedRoute><SearchPage /></ProtectedRoute>} />
            <Route path="/orders/new"  element={<ProtectedRoute><NewOrderPage /></ProtectedRoute>} />
            <Route path="/orders/:id"  element={<ProtectedRoute><OrderDetailPage /></ProtectedRoute>} />

            {/* Admin only */}
            <Route path="/financials"   element={<ProtectedRoute requireAdmin><FinancialsPage /></ProtectedRoute>} />
            <Route path="/productivity" element={<ProtectedRoute requireAdmin><ProductivityPage /></ProtectedRoute>} />
            <Route path="/call-report"  element={<ProtectedRoute requireAdmin><CallReportPage /></ProtectedRoute>} />
            <Route path="/admin"        element={<ProtectedRoute requireAdmin><AdminPage /></ProtectedRoute>} />

            {/* Catch-all */}
            <Route path="*" element={<Navigate to="/queue" replace />} />
          </Routes>
          </ReportFiltersProvider>
        </LookupProvider>
      </AuthProvider>
    </BrowserRouter>
  );
}
